import React, { useState, useEffect, useMemo } from 'react';
import { formatters } from '../../../../Core/Controls';
import { useWindowSize } from '../../../../Core/Hooks/useWindowSize';
import { AppStorage } from '../../../../Core/Basic/storage-service';
import { useLoginInfo } from '../../../../Core/Hooks/useLoginInfo';
import { useHistory } from 'react-router-dom';
import GijgoGrid from '../../../../Core/Controls/GijgoGrid';
import ReactDOM from 'react-dom';

const base_columns = [
    //Date, Part number, part description, qty, status, warehouse, purchased from, job reference

    // { key: 'action', name: 'Action', width: 120, addFileUploaderIcon: true },
    { key: 'added', name: 'Date', formatter: formatters.Date_DDMMYYYY, width: 90 },
    // { key: 'jobDescription', name: 'Date.', width: 150 },
    { key: 'partNumber', name: 'Part Number', width: 150 },
    { key: 'part', name: 'Part Description' },
    { key: 'quantity', name: 'Qty', width: 60 },
    { key: 'status', name: 'Status', width: 130 },
    { key: 'warehouse', name: 'Warehouse', width: 145 },
    { key: 'purchasedFrom', name: 'Purchased From' },
    { key: 'jobReference', name: 'Job Feference', width: 150 }
];

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Jobs', active: true },
    { name: 'All Jobs', active: true }
];

function VehicleUsedParts(props) {
    const [width, height] = useWindowSize();
    let checkhaveAccess = AppStorage.getAllowAcces();
    const isInternal = useLoginInfo().userRoles.includes('internal');
    const history = useHistory();

    const [state, setState] = useState({
        getUrl: `Vehicle_PartsUsed/Vehicle_PartsUsed_List?VehicleID=${props.VehicleID}` || ''
    });

    // useEffect(async () => {
    //     pullJobList();
    // }, [props.VehicleID]);

    // const pullJobList = async () => {
    //     setState((st) => ({
    //         ...st,
    //         isReload: new Date()
    //     }));
    // };

    const redirectToJobDetails = (jobID) => {
        history.push({
            pathname: `/controller/jobTabScreen/${jobID}/${props.VehicleID}`,
            state: 'jobs',
            search: 'tab_testing_tabs=1'
        });
    };

    const renderJobRefEdit = ({ row, col }, grid) => {
        const spn = document.createElement('span');
        const lnk = (
            <div onClick={() => redirectToJobDetails(row.jobID)} style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }}>
                {row.jobReference}
            </div>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        let newColumn = [...base_columns];
        let jobRef = newColumn.find((item) => item.key === 'jobReference');
        if (jobRef) {
            jobRef.formatter = renderJobRefEdit;
        }

        return newColumn;
    }, []);

    return (
        <div style={{ marginTop: 8 }}>
            <GijgoGrid
                columns={columns}
                // btnTitle={gridBtnTitle}
                // onBtnClick={jobHandler}
                // idFieldName={`${checkhaveAccess?.CanUploadJobDocuments ? 'jobID' : null}`}
                // fileUploaderConfigName={`${checkhaveAccess?.CanUploadJobDocuments ? 'JobScreen' : null}`}
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                // onRowDataBound={(e, $row, id, record, GridRef) => onRowDataBound(e, $row, id, record, GridRef)}
                isReload={state.isReload}
                getUrl={state.getUrl}
            />
        </div>
    );
}
export default VehicleUsedParts;
